// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1qWJb","label":"SetPasswdForm_label__2Yv16"};